/* Metabella — Sale-Countdown pro Besucher.
   Die Restzeit wird im Browser der Person gemerkt. Ein Reload oder ein
   Seitenwechsel setzt sie nicht zurueck; der Zaehler folgt der Zeit, die
   die Person wirklich da war. Laeuft er ab, startet er neu.
   Ist in der Section ein festes Enddatum gesetzt, gilt weiter das Datum. */
(function () {
  var PREFIX = 'wb-sale-countdown:';
  var mem = {};

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function durationOf(root) {
    var d = parseInt(root.getAttribute('data-wb-duration'), 10);
    return d > 0 ? d : 4358;
  }

  function keyOf(root) {
    return PREFIX + (root.getAttribute('data-wb-key') || 'bar') + ':' + durationOf(root);
  }

  function fixedDeadline(root) {
    var raw = root.getAttribute('data-wb-deadline');
    if (!raw) return null;
    var d = new Date(raw);
    return isNaN(d.getTime()) ? null : d.getTime();
  }

  function deadlineOf(root) {
    var fixed = fixedDeadline(root);
    if (fixed !== null) return fixed;

    var key = keyOf(root);
    var dur = durationOf(root) * 1000;
    var now = Date.now();
    var v = mem[key];
    if (v === undefined) v = lsGet(key);
    v = parseInt(v, 10);

    if (!v || isNaN(v) || v <= now || v > now + dur + 60000) {
      v = now + dur;
      lsSet(key, String(v));
    }
    mem[key] = v;
    return v;
  }

  function tickAll() {
    var bars = document.querySelectorAll('[data-wb-bar]');
    for (var i = 0; i < bars.length; i++) {
      var root = bars[i];
      var hEl = root.querySelector('[data-h]');
      var mEl = root.querySelector('[data-m]');
      var sEl = root.querySelector('[data-s]');
      var diff = Math.max(0, Math.floor((deadlineOf(root) - Date.now()) / 1000));

      if (diff <= 0 && fixedDeadline(root) !== null && root.getAttribute('data-wb-hide') === '1') {
        root.style.display = 'none';
        continue;
      }
      if (!hEl || !mEl || !sEl) continue;
      hEl.textContent = pad(Math.floor(diff / 3600));
      mEl.textContent = pad(Math.floor((diff % 3600) / 60));
      sEl.textContent = pad(diff % 60);
    }
  }

  /* Die Leiste kommt in den festen Platz [data-wb-bar-slot], den
     sections/header.liquid als erstes Kind von #header-component rendert.
     Frueher wurde sie direkt als erstes Kind eingefuegt. Das Theme gleicht
     den Header nach jeder Warenkorb-Aenderung Position fuer Position mit dem
     Server-HTML ab (morph) — das zusaetzliche Kind verschob alles um eins:
     der Cart-Drawer wurde neu gebaut (ging nach Add-to-Cart nicht auf bzw.
     verschwand beim Umschalten der Versandsicherung) und die Leiste selbst
     wurde zu einem anderen Element umgebaut. Ohne Platz bleibt die Leiste
     deshalb lieber, wo sie ist. */
  function moveIntoHeader() {
    var bar = document.querySelector('[data-wb-bar]');
    var header = document.getElementById('header-component');
    if (!bar || !header) return false;
    if (bar.dataset.wbMoved) return true;
    var slot = header.querySelector('[data-wb-bar-slot]');
    if (!slot) return false;
    slot.appendChild(bar);
    bar.dataset.wbMoved = '1';
    return true;
  }

  function start() {
    tickAll();
    setInterval(tickAll, 1000);
    window.addEventListener('pageshow', tickAll);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tickAll();
    });
    if (!moveIntoHeader()) {
      var tries = 0;
      var t = setInterval(function () {
        if (moveIntoHeader() || ++tries > 40) clearInterval(t);
      }, 150);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
